import { render } from "./remediation_revision_details.vue?vue&type=template&id=012e5a20"
import script from "./remediation_revision_details.vue?vue&type=script&lang=js"
export * from "./remediation_revision_details.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__